import { checkDate } from "common/helpers/Date";
import { FileRecord, IFileData, fileFromJSON } from "common/records/File";
import { Nullable } from "common/types";
import { Record } from "immutable";
import { DateStringNumber } from ".";

export const slideFromJSON = (json: Partial<ISlideData>): SlideRecord => {
  const data: ISlideRecord = { ...(json as any) };

  if (json.cover_image) {
    data.cover_image = fileFromJSON(json.cover_image);
  }

  if (json.created_at) {
    data.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    data.updated_at = checkDate(json.updated_at);
  }

  return new SlideRecord(data);
};

export const toJSON = (record: SlideRecord): ISlideData => {
  const slide: ISlideData = record.toJSON() as any as ISlideData;

  if (slide.id <= 0) {
    delete (slide as any).id;
  }

  return slide;
};

export interface ISlideData {
  id: number;
  cover_image: IFileData;
  html: string;
  name: string;
  presentation_id: number;
  sort_order: number;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface ISlideRecord {
  id: number;
  cover_image: Nullable<FileRecord>;
  html: string;
  name: string;
  presentation_id: Nullable<number>;
  sort_order: number;
  loading: boolean;

  created_at: Date;
  updated_at: Date;
}

const defaultSlideProps: ISlideRecord = {
  id: 0,
  cover_image: null,
  html: "",
  name: "",
  presentation_id: null,
  sort_order: 0,
  loading: false,
  created_at: new Date(),
  updated_at: new Date(),
};

export class SlideRecord extends Record(defaultSlideProps) implements ISlideRecord {}
